/**
 * Utilidad para catálogos con clave: convierte la lista de valores de un
 * enumerado (`['active', 'paid'] as const`) en un objeto `{ active: 'active',
 * paid: 'paid' }`. Así el código usa `LOAN_STATUS.active` en lugar del
 * literal suelto `'active'`, conserva el tipo literal (Drizzle y Zod lo
 * aceptan sin conversión) y un error tipográfico falla en compilación.
 */
/**
 * Construye un catálogo con clave a partir de la lista de valores de un
 * enumerado. El objeto resultante está congelado.
 *
 * @example
 * const LOAN_STATUS = keyedEnum(LOAN_STATUSES)
 * LOAN_STATUS.active // tipo 'active'
 */
export function keyedEnum(values) {
    const entries = values.map((value) => [value, value]);
    return Object.freeze(Object.fromEntries(entries));
}
//# sourceMappingURL=enum.js.map